<mat-dialog-content class="header">
  <h2 class="text-center">Season Confirmation</h2>
</mat-dialog-content>
<p class="text-center px-2">Which season are you wanting to view/work in? Note you can always change your season selection using the Season dropdown in the upper right hand corner of your dashboard.</p>
<div class="scroll-container">
  <div class="row justify-content-center mt-2">
    <div class="col-10 col-md-8">
      <eq-dropdown [name]="'seasonId'" [form]="form" [label]="'Select Season to Continue'" [options]="seasionOptions"
        [validators]="seasonValidator" [multiSelect]="false"></eq-dropdown>
    </div>
  </div>
</div>

<div class="d-flex row justify-content-around m-0 p-0">
  <div class="col text-center mb-3">
    <button mat-flat-button color="primary" type="submit" class="next-btn" (click)="next()" [disabled]="!form.valid">
      <span>Continue<mat-icon>arrow_right</mat-icon></span>
    </button>
  </div>
</div>